import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMedicalBuilding = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.5 21.375V15.125C9.5 14.7935 9.6317 14.4755 9.86612 14.2411C10.1005 14.0067 10.4185 13.875 10.75 13.875H19.5C19.8315 13.875 20.1495 14.0067 20.3839 14.2411C20.6183 14.4755 20.75 14.7935 20.75 15.125V21.375H7"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 10.125V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.25 13.875V10.7658"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 6.375C4.5 7.36956 4.89509 8.32339 5.59835 9.02665C6.30161 9.72991 7.25544 10.125 8.25 10.125C9.24456 10.125 10.1984 9.72991 10.9016 9.02665C11.6049 8.32339 12 7.36956 12 6.375C12 5.38044 11.6049 4.42661 10.9016 3.72335C10.1984 3.02009 9.24456 2.625 8.25 2.625C7.25544 2.625 6.30161 3.02009 5.59835 3.72335C4.89509 4.42661 4.5 5.38044 4.5 6.375V6.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 5.125V7.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 6.375H9.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.75 13.875H7"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.75 17.625H7"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.625 18.8908H13.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.375 18.8908H17.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.625 16.3908H13.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.375 16.3908H17.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMedicalBuilding.displayName = 'SvgMedicalBuilding';
export default SvgMedicalBuilding;
